import React, { FC } from 'react';
import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import { EScoreRating } from '../../../../services/individualReport';
import { THEME as theme } from '../../../../styles/theme';

const COLORS: Record<EScoreRating, string> = {
  [EScoreRating.STRONG]: theme.colors.accent.green[100],
  [EScoreRating.NORMAL]: theme.colors.accent.blue[100],
  [EScoreRating.WEAK]: theme.colors.accent.red[100],
};

const styles = StyleSheet.create({
  legend: {
    display: 'flex',
    width: '100%',
    margin: `${theme.layout.spacing.mikro} 0 0 auto`,
    flexDirection: 'row',
    gap: 16,
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  bar: {
    width: 24,
    height: 6,
    borderRadius: 4,
  },
  text: {
    fontSize: 8,
  },
});

const Legend: FC = () => {
  const { t } = useTranslation();

  return (
    <View style={styles.legend}>
      {Object.values(EScoreRating).map(level => (
        <View style={styles.content} key={level}>
          <View style={[styles.bar, { backgroundColor: COLORS[level] }]} />
          <Text style={styles.text}>{t(`results.report.pdf.legend.${level}`)}</Text>
        </View>
      ))}
    </View>
  );
};

export default Legend;
